import React from 'react';
import { Link } from 'react-router-dom';

const s = {
  page:    { position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'clamp(1.25rem, 5vw, 3rem)', overflow: 'hidden' },
  bg:      { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' },
  panel:   { position: 'relative', maxWidth: '620px', background: 'rgba(15,20,32,0.6)', backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)', borderRadius: '24px', padding: 'clamp(1.75rem, 5vw, 2.75rem) clamp(1.5rem, 5vw, 3rem)', textAlign: 'center', color: '#fff' },
  eyebrow: { fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#9FC2EA', marginBottom: '1rem' },
  h1:      { fontFamily: "'Playfair Display', serif", fontWeight: 600, fontSize: 'clamp(1.7rem, 5vw, 2.6rem)', lineHeight: 1.15, margin: '0 0 1.1rem' },
  p:       { fontSize: 'clamp(0.9rem, 2vw, 1rem)', lineHeight: 1.7, color: '#D8DEE6', margin: '0 0 0.9rem' },
  footer:  { marginTop: '1.5rem', fontSize: '0.75rem', color: '#9AA8B8' },
  link:    { color: '#9AA8B8' },
};

export default function ClosedPage() {
  return (
    <main style={s.page}>
      <img style={s.bg} src="/images/seminars-hero.webp" alt="" />
      <div style={s.panel}>
        <div style={s.eyebrow}>ArmenianPlace</div>
        <h1 style={s.h1}>ArmenianPlace has closed</h1>
        <p style={s.p}>
          We set out to build free seminars taught by the Armenian community, for the community.
          Unfortunately, there weren’t enough signups to make it work, so we’ve decided to close the project.
        </p>
        <p style={s.p}>
          Thank you to everyone who signed up, suggested a topic, or offered to speak. Շնորհակալություն։
        </p>
        <div style={s.footer}>
          <Link to="/privacy" style={s.link}>Privacy</Link> · <Link to="/terms" style={s.link}>Terms</Link>
        </div>
      </div>
    </main>
  );
}
